// src/Layout.jsx

import React, { useState, useEffect } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Layout.css'; // Your custom CSS

export default function Layout({ userType, setIsAuthenticated }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [submenuOpen, setSubmenuOpen] = useState({
    performance: false,
    enginePerformance: false,
    hullCleaning: false,
    admin: false,
    templates: false,
    databases: false,
  });
  const [currentTime, setCurrentTime] = useState(new Date());
  const [userName, setUserName] = useState('');
  const navigate = useNavigate();

  // Update clock every second
  useEffect(() => {
    const interval = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  // Load firstName from localStorage for greeting
  useEffect(() => {
    const stored = localStorage.getItem('user');
    if (stored) {
      try {
        setUserName(JSON.parse(stored).firstName);
      } catch {}
    }
  }, []);

  const toggleSidebar = () => setSidebarOpen(open => !open);
  const toggleSubmenu = key =>
    setSubmenuOpen(prev => ({ ...prev, [key]: !prev[key] }));

  const handleLogout = () => {
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    navigate('/login', { replace: true });
  };

  const arrow = isOpen => (isOpen ? '▼' : '►');
  const canSeeAdvanced = ['Super Admin', 'Admin', 'Company Admin'].includes(userType);
  const isSuperAdmin = userType === 'Super Admin';

  return (
    <div className="d-flex" style={{ minHeight: '100vh' }}>
      {/* Sidebar */}
      {sidebarOpen && (
        <div className="sidebar">
          <div className="p-3">
            <h1>alicia</h1>
            <nav>
              <ul className="nav flex-column">
                <li className="nav-item">
                  <Link to="/app/map" className="nav-link custom-nav-link">
                    Map
                  </Link>
                </li>
                {canSeeAdvanced && (
                  <>
                    <li className="nav-item">
                      <Link to="/app/ais-data" className="nav-link custom-nav-link">
                        AIS Data
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/app/advanced-analytics"
                        className="nav-link custom-nav-link"
                      >
                        Advanced Analytics
                      </Link>
                    </li>
                  </>
                )}
                <li className="nav-item">
                  <Link to="/app/analytics" className="nav-link custom-nav-link">
                    Vessel Analytics
                  </Link>
                </li>

                {/* Performance */}
                <li className="nav-item">
                  <span
                    onClick={() => toggleSubmenu('performance')}
                    className="nav-link custom-nav-link"
                    style={{ cursor: 'pointer' }}
                  >
                    Performance {arrow(submenuOpen.performance)}
                  </span>
                  {submenuOpen.performance && (
                    <ul className="nav flex-column submenu">
                      <li className="nav-item">
                        <Link
                          to="/app/performance/new-report"
                          className="nav-link custom-nav-link"
                        >
                          New Report
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/app/performance/records"
                          className="nav-link custom-nav-link"
                        >
                          Performance Records
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Engine Performance */}
                <li className="nav-item">
                  <span
                    onClick={() => toggleSubmenu('enginePerformance')}
                    className="nav-link custom-nav-link"
                    style={{ cursor: 'pointer' }}
                  >
                    Engine Performance {arrow(submenuOpen.enginePerformance)}
                  </span>
                  {submenuOpen.enginePerformance && (
                    <ul className="nav flex-column submenu">
                      <li className="nav-item">
                        <Link
                          to="/app/engine-performance/new-report"
                          className="nav-link custom-nav-link"
                        >
                          New Report
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/app/engine-performance/records"
                          className="nav-link custom-nav-link"
                        >
                          Engine Records
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Hull Cleaning */}
                <li className="nav-item">
                  <span
                    onClick={() => toggleSubmenu('hullCleaning')}
                    className="nav-link custom-nav-link"
                    style={{ cursor: 'pointer' }}
                  >
                    Hull Cleaning {arrow(submenuOpen.hullCleaning)}
                  </span>
                  {submenuOpen.hullCleaning && (
                    <ul className="nav flex-column submenu">
                      <li className="nav-item">
                        <Link
                          to="/app/hull-cleaning/new-report"
                          className="nav-link custom-nav-link"
                        >
                          New Report
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/app/hull-cleaning/records"
                          className="nav-link custom-nav-link"
                        >
                          Cleaning Records
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Admin (Super Admin only) */}
                {isSuperAdmin && (
                  <li className="nav-item">
                    <span
                      onClick={() => toggleSubmenu('admin')}
                      className="nav-link custom-nav-link"
                      style={{ cursor: 'pointer' }}
                    >
                      Admin {arrow(submenuOpen.admin)}
                    </span>
                    {submenuOpen.admin && (
                      <ul className="nav flex-column submenu">
                        <li className="nav-item">
                          <Link
                            to="/app/admin/users"
                            className="nav-link custom-nav-link"
                          >
                            Users
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/app/admin/ships"
                            className="nav-link custom-nav-link"
                          >
                            Ships
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/app/admin/company"
                            className="nav-link custom-nav-link"
                          >
                            Company
                          </Link>
                        </li>

                        {/* Templates */}
                        <li className="nav-item">
                          <span
                            onClick={() => toggleSubmenu('templates')}
                            className="nav-link custom-nav-link"
                            style={{ cursor: 'pointer' }}
                          >
                            Templates {arrow(submenuOpen.templates)}
                          </span>
                          {submenuOpen.templates && (
                            <ul className="nav flex-column submenu">
                              <li>
                                <Link
                                  to="/app/admin/templates/operational"
                                  className="nav-link custom-nav-link"
                                >
                                  Operational
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/app/admin/templates/performance"
                                  className="nav-link custom-nav-link"
                                >
                                  Performance
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/app/admin/templates/position"
                                  className="nav-link custom-nav-link"
                                >
                                  Position
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/app/admin/templates/weather"
                                  className="nav-link custom-nav-link"
                                >
                                  Weather
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/app/admin/templates/technical"
                                  className="nav-link custom-nav-link"
                                >
                                  Technical
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/app/admin/templates/engine"
                                  className="nav-link custom-nav-link"
                                >
                                  Engine
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/app/admin/templates/rob"
                                  className="nav-link custom-nav-link"
                                >
                                  ROB
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/app/admin/templates/calculated"
                                  className="nav-link custom-nav-link"
                                >
                                  Calculated
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/app/admin/templates/engine-performance"
                                  className="nav-link custom-nav-link"
                                >
                                  Engine Performance
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/app/admin/templates/template-map"
                                  className="nav-link custom-nav-link"
                                >
                                  Template Map
                                </Link>
                              </li>
                            </ul>
                          )}
                        </li>

                        {/* Databases */}
                        <li className="nav-item">
                          <span
                            onClick={() => toggleSubmenu('databases')}
                            className="nav-link custom-nav-link"
                            style={{ cursor: 'pointer' }}
                          >
                            Databases {arrow(submenuOpen.databases)}
                          </span>
                          {submenuOpen.databases && (
                            <ul className="nav flex-column submenu">
                              <li>
                                <Link
                                  to="/app/admin/databases/ships"
                                  className="nav-link custom-nav-link"
                                >
                                  Ships
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/app/admin/databases/users"
                                  className="nav-link custom-nav-link"
                                >
                                  Users
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/app/admin/databases/companies"
                                  className="nav-link custom-nav-link"
                                >
                                  Companies
                                </Link>
                              </li>
                            </ul>
                          )}
                        </li>
                      </ul>
                    )}
                  </li>
                )}
              </ul>
            </nav>
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className="flex-grow-1">
        <nav
          className="navbar navbar-expand-lg navbar-light bg-light border-bottom"
          style={{ minHeight: '56px' }}
        >
          <div className="container-fluid">
            <button className="btn btn-primary" onClick={toggleSidebar}>
              {sidebarOpen ? '<' : '>'}
            </button>

            {/* Centered vessel selector, greeting, logout */}
            <div className="mx-auto d-flex align-items-center">
              {/* add vessel dropdown here if needed */}
            </div>
            <div className="ms-auto d-flex align-items-center">
              <span className="me-3">{currentTime.toLocaleString()}</span>
              <span className="me-3">Hello {userName}</span>
              <button className="btn btn-outline-danger" onClick={handleLogout}>
                Log Out
              </button>
            </div>
          </div>
        </nav>
        <div className="container-fluid mt-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
